<template>
   <v-card>
        <v-layout>
            <v-flex xs12>
                <v-layout>
                    <v-flex xs12>
                        <h1 class="text-xs-center">Spray Configuration</h1>
                    </v-flex>
                </v-layout>
                <v-layout wrap>
                   <v-flex xs12 sm3 offset-sm1>
                        <v-text-field
                            v-model="search"
                            append-icon="search"
                            label="Filter Product / Chemical"
                            single-line
                            hide-details
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm3 offset-sm1>
                        <v-checkbox
                            class="active-checkbox"
                            label="Active Only"
                            v-model="activeOnly"
                             hide-details
                        ></v-checkbox>
                    </v-flex>
                     <v-flex xs12 sm2 offset-sm1>
                        <v-btn
                            color="primary"
                            block
                            @click="showEditAddSpray()">
                            Add
                        </v-btn>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex xs12>
                        <v-data-table
                            :headers="headers"
                            :items="sprayConfigurations"
                            :search="search"
                            :rows-per-page-items="rowsPerPageItems"
                            :pagination.sync="pagination"
                            must-sort>
                            <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
                            <template slot="items" slot-scope="props">
                                <td>{{props.item.ProductChemical}}</td>
                                <td>{{props.item.WithholdPeriod}}</td>
                                <td>{{props.item.ValidPeriod}}</td>
                                <td>{{props.item.Status ? 'Active' : 'Inactive'}}</td>
                                <td> 
                                    <v-btn
                                            color="primary"
                                            block
                                            @click="editSpray(props.item)">
                                            Edit
                                    </v-btn>
                                </td>
                            </template>
                        </v-data-table>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>

        <!-- Add edit dialog -->
             <v-dialog v-model="showAddSprayDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-btn icon dark :disabled="saving" @click="cancelEditSpray">
                            <v-icon large>close</v-icon>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-toolbar-title v-if="editedSpray.Editing">Edit Spray</v-toolbar-title>
                        <v-toolbar-title v-else>Add New Spray</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-form ref="editForm" v-model="editSprayValid">
                        <v-layout class="dialog-content">      
                            <v-flex xs12 md6 offset-md3 mt-4 >
                                <v-layout wrap>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="editedSpray.ProductChemical"
                                            :rules="[rules.required, rules.maxfiftyCharacters]"
                                            counter
                                            label="Product / Chemical">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="editedSpray.WithholdPeriod"
                                            :rules="[rules.From0To9999]"
                                            label="Withhold Period">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="editedSpray.ValidPeriod"
                                            :rules="[rules.From0To9999]"
                                            label="Valid Period">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-checkbox v-model="editedSpray.Status" label="Active Status"></v-checkbox>
                                    </v-flex>
                                </v-layout>
                                <v-layout wrap class="dialog-action-buttons">
                                    <v-flex xs12 sm6>
                                        <v-btn block color="success" :disabled="!editSprayValid" :loading="saving" @click="saveSpray">Save</v-btn>
                                    </v-flex>
                                    <v-flex xs12 sm6 >
                                        <v-btn block color="error" :disabled="saving" @click="cancelEditSpray">Cancel</v-btn>
                                    </v-flex>
                                    <v-flex xs12>
                                         <v-alert :value="saveError"
                                                outline
                                                type="error">
                                                {{saveError}}
                                        </v-alert>
                                    </v-flex>
                                </v-layout>                            
                            </v-flex>
                        </v-layout>
                    </v-form>
                </v-card>
            </v-dialog>
    </v-card>
</template>

<script>
import validationRules from "../../helpers/validationrules";
 
export default {
    data() {
        return {
            search: "",
            activeOnly: true,
            saving: false,
            showAddSprayDialog: false,
            editedSpray: {},
            editSprayValid: false,
            saveError: null,
            rules: validationRules.rules,
            pagination: {
                page: 1,
                rowsPerPage: 25,
                descending: false
            },
            rowsPerPageItems: [10, 25, 50, 100],
            headers: [
                {
                    text: "Product / Chemical",
                    value: "ProductChemical",
                    align: 'left',
                },
                {
                    text: "Withhold Period (hrs)",
                    value: "WithholdPeriod",
                    align: 'left'
                },
                {
                    text: "Valid Period (hrs)",
                    value: "ValidPeriod",
                    align: 'left'
                },
                 {
                    text: "Active Status",
                    value: "Status",
                    align: 'left'
                },
                {
                    text: "Edit",
                    value: "",
                    align: "left",
                    sortable: false
                }
            ]
        }
    },
    computed: {
        sprayConfigurations() {
            return this.$store.getters["ConfigurationStore/getSprayConfigurations"].filter(u => u.Status || !this.activeOnly);
        }
    },
    methods: {
        editSpray(spray) {
            this.showEditAddSpray(Object.assign({}, spray));
        },
        showEditAddSpray(spray) {
            if(spray) {
                this.editedSpray = spray;
                this.editedSpray.Editing = true;
            } else {
                this.editedSpray = {Editing: false, Status: true};
            }
            this.showAddSprayDialog = true;
            this.saveError = null;
        },
        cancelEditSpray() {
            this.showAddSprayDialog = false;
            this.editedSpray = {};
            this.$refs.editForm.reset();
        },
        async saveSpray() {
            var that = this;
            that.saving = true;
            that.saveError = null;
            try{
                var result = await this.$store.dispatch("ConfigurationStore/saveSprayConfiguration", this.editedSpray);
                if(result != null && result.Success == false) {
                    that.saveError = result.ErrorMessage;
                } else {
                    that.cancelEditSpray();
                }
                
            } catch(error) {
                that.saveError = error;
            } finally {
                that.saving = false;
            }
        }
    },
    created() {

    }
}
</script>

<style>

</style>
